import React, { Fragment } from 'react';
import { useSelector } from 'react-redux';
import { CircularProgress } from '@material-ui/core';
import AppState from '../../../models/redux/state/app.state';
import './LocalSpinner.css';

const LocalSpinner = (): JSX.Element => {
  const isLoading = useSelector((state: AppState) => state.spinner.localSpinner.isVisible);

  return (
    <Fragment>
      {isLoading ? (
        <div className="spinner-container">
          <CircularProgress size={100} />
        </div>
      ) : null}
    </Fragment>
  );
};

export default LocalSpinner;
